export default __webpack_public_path__ + "static/media/water.7a644e1a.jpg";